import { AdditionalInfoLinkProps } from '@components/container/AdditionalInfoLink';
import { InputLabelContainer } from '@components/container/InputLabelContainer';
import { QFCTypeExecuted } from '@components/quoteDetails/QuoteFieldControl';
import { Item } from '@components/select/Select';
import { ToggleButtonGroup, ToggleButton, FormControl } from '@mui/material';
import { useStore } from '@store/GlobalStore';
import { adjustFieldHeight } from '@theme/styleOverrides/typography';
import { ReactNode, useId } from 'react';
import { shallow } from 'zustand/shallow';

export interface RadioButtonGroupProps {
  onChange: (value: any) => void;
  items: Item[];
  disabled?: boolean;
  label: string | null;
  value?: any;
  helperText?: string;
  errorMessage?: string;
  attributeType: QFCTypeExecuted['attributeType'];
  isRequired?: boolean;
  isReadOnly?: boolean;
  inputLabelIcon?: ReactNode;
  tooltipTitle?: ReactNode;
  additionalInfoLink?: AdditionalInfoLinkProps;
  deprecated?: boolean | null;
  requiredBeforeBind?: boolean;
}

export const RadioButtonGroup = ({
  items,
  value,
  label,
  onChange,
  disabled,
  errorMessage,
  attributeType,
  isReadOnly,
  isRequired,
  inputLabelIcon,
  tooltipTitle,
  additionalInfoLink,
  requiredBeforeBind,
}: RadioButtonGroupProps) => {
  const [layoutPreferences] = useStore((state) => [state.layoutPreferences], shallow);
  const fieldId = useId();
  const labelId = `${fieldId}-label`;

  const hasError = !!errorMessage;
  return (
    <FormControl required={isRequired} disabled={isReadOnly} error={hasError}>
      <InputLabelContainer
        additionalInfoLink={additionalInfoLink}
        inputLabelProps={{
          id: fieldId,
          children: label,
          error: !!errorMessage,
          disabled: isReadOnly,
          required: isRequired,
          requiredBeforeBind,
          endIcon: inputLabelIcon,
          tooltipTitle,
          deprecated: attributeType.deprecated,
        }}
        helperLabelProps={{
          children: errorMessage ?? attributeType.helpText ?? ' ',
          error: hasError,
          disabled: isReadOnly,
        }}
      >
        <ToggleButtonGroup
          sx={{
            height: `${adjustFieldHeight(36, layoutPreferences.fontSize)}px`,
          }}
          disabled={disabled}
          value={value}
          exclusive
          onChange={(_, value) => {
            onChange(value);
          }}
          aria-labelledby={labelId}
        >
          {items.map((option) => (
            <ToggleButton
              sx={{
                height: '100%',
                borderColor: hasError ? 'other.error' : 'text.main',
              }}
              className={hasError ? 'error' : ''}
              key={option.value}
              value={option.value}
            >
              {option.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </InputLabelContainer>

      {/* <FormHelperText error={hasError}>{errorMessage ?? helperText ?? ' '}</FormHelperText> */}
    </FormControl>
  );
};
